import FormAngebotDto from "./FormAngebotDto";
import FormIhrTierDto from "./FormIhrTierDto";
import FormAntragDto from "./FormAntragDto";

export default class FormulardatenDto {
    antrag?: FormAntragDto;

    ihrTier?: FormIhrTierDto;

    angebot?: FormAngebotDto;
}